import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../shared/configuration.service';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { Subject  } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { AnalyticsService } from '../analytics/analytics.service';


@Injectable()
export class PaymentService {

  constructor(private http: Http,
    private _configuration: ConfigurationService,
    private _analyticsService: AnalyticsService

  ) {

  }

  private requestOptions(): RequestOptions {
    const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
    const options = new RequestOptions({ headers: headers});
    return options;
  }
  GetTrackedGifts(): Observable<TrackedGiftCollection> {

    return this.http.get(this._configuration.baseUrl + '/api/track', this.requestOptions())
      .map((res: any) => {

       return (res.json() as TrackedGiftCollection);
      })
      .catch(this.handleError);
  }

  AddThankYou(formBody: string): Observable<any> {
     return this.http.post(this._configuration.baseUrl + '/api/payments/thank-you', formBody, this.requestOptions())
      .map(response => {
          this._analyticsService.trackEvent('thank you added', null);

        return response; })
      .catch(this.handleError);




  }

  GetPayEngineBalance(authCode: string): Observable<any> {
    return this.http.post(environment.firebase.clouldFunctionHost + '/getMerchantBalance', {
      idToken:authCode
    }, this.requestOptions())
    .map(response => {


      return response; })
    .catch(this.handleError);




 }

  /**
   * Gets the balance history from the PayEngine API
   * @param authCode The user's authentication token
   * @returns Observable with the balance history response
   */
  GetBalanceHistory(authCode: string): Observable<any> {
    return this.http.post(environment.firebase.clouldFunctionHost + '/getBalanceHistory', {
      idToken: authCode
    }, this.requestOptions())
    .map(response => {
      return response; 
    })
    .catch(this.handleError);
  }


  CancelContribution(formBody:string): Observable<any> {
  return this.http.post(environment.firebase.clouldFunctionHost + '/cancelContribution', formBody, this.requestOptions())
    .map(response => {
      

      return response; })
    .catch(this.handleError);


  }

  AddWish(formBody: string): Observable<any> {
     return this.http.post(environment.firebase.clouldFunctionHost + '/createWish', formBody, this.requestOptions())
      .map(response => {
        this._analyticsService.trackEvent('wish added', null);

        return response; })
      .catch(this.handleError);

  }
  GetContriubtionFromToken(contributionToken: string): Observable<any> {
    return this.http.get(environment.firebase.clouldFunctionHost + '/validateContribution?contributionKey='+contributionToken, this.requestOptions())
     .map(response => {

       return response; })
     .catch(this.handleError);

 }

  ConfirmPayment(formBody: string): Observable<any> {
    return this.http.post(environment.firebase.clouldFunctionHost + '/confirmPayment', formBody, this.requestOptions())
     .map(response => {
       return response; })
     .catch(this.handleError);

 }
 MarkAsPaid(formBody: string): Observable<any> {
  return this.http.post(environment.firebase.clouldFunctionHost + '/markAsPaid', formBody, this.requestOptions())
   .map(response => {
     return response; })
   .catch(this.handleError);

}

SetAsIHavePaid(formBody: string): Observable<any> {
  return this.http.post(environment.firebase.clouldFunctionHost + '/setIHavePaid', formBody, this.requestOptions())
   .map(response => {
     return response; })
   .catch(this.handleError);

}


sendTextGuestEmail(recaptchaToken:string, fbAuthToken: string): Observable<any>  {

let requestBody = {
token: recaptchaToken,
auth: fbAuthToken

}
  const formBody = JSON.stringify(requestBody);

return this.http.post(environment.firebase.clouldFunctionHost + '/sendTestGuestEmail', formBody, this.requestOptions())
.map(response => {

return response; })
.catch(this.handleError);

}



  SendThankYouEmail(formBody: string): Observable<any> {
     return this.http.post(environment.firebase.clouldFunctionHost + '/sendThankYouEmail', formBody, this.requestOptions())
      .map(response => {
        // this._analyticsService.trackEvent('wish added', null)

        return response; })
      .catch(this.handleError);

  }


  
  private handleError(error: Response | any): Observable<any> {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
       errMsg = body.error || JSON.stringify(body);

    }

    return Observable.of({error: errMsg});
  }

  /**
   * Creates a transfer for the merchant's available balance
   * @param idToken The user's auth token
   * @returns Observable with the transfer response
   */
  CreateTransfer(idToken: string) {
    const url = environment.firebase.clouldFunctionHost + '/createTransfer';
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const body = { idToken: idToken };

    return this.http.post(url, body, options);
  }

}







// WEBPACK FOOTER //
// ./src/app/payment/payment.service.ts